import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RecommandationsFormComponent } from '../community/recommandations-form/recommandations-form.component';
import { environment } from 'src/environments/environment';
import { AppState } from 'src/app/shareModule/states/app.state';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, filter } from 'rxjs';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { User } from 'src/app/shareModule/models/user.model';

@Component({
  selector: 'app-recommend-page',
  templateUrl: './recommend-page.component.html',
  styleUrl: './recommend-page.component.scss'
})
export class RecommendPageComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private modalService: NgbModal,
    private store: Store<AppState>,
  ) {

  }

  public recommendations = []
  public myRecommendations = []
  public catsCount = []

  private user: any;




  public allProductsCount = 0

  public get areAllSelected() {
    return this.catsCount.filter(cat => cat.recommendationCounts && cat.name?.trim()).every(cat => cat.selected)
  }
  public selectAll() {
    if (this.areAllSelected) {
      this.catsCount.forEach(cat => cat.selected = false);
      this.fetchRecommdations();

      return
    }

    this.catsCount.forEach(cat => cat.selected = true);


    this.fetchRecommdations();

  }

  public selectcat(cat) {
    console.log("selecting", cat)
    cat.selected = !cat.selected;
    // if(cat.selected){
    //   this.selectedCats.push(cat.id)

    // }else{
    //   this.selectedCats.splice(this.selectedCats.indexOf(cat.categorieChildId), 1)
    // }
    this.fetchRecommdations();
  }
  private filterMyRecommendations() {
    this.myRecommendations = Array.from(this.recommendations.filter(recommemdation => recommemdation.memberId == this.user?.id))
  }
  private fetchRecommdations() {
    if (this.local.getUser() == null) {
      return;
    }
    this.auth.getallrecommendations({
      categries: this.catsCount.filter(cat => cat.selected).map(cat => cat.id)
    })
      .subscribe({
        next: (data: any) => {
          this.recommendations = data.data;
          this.filterMyRecommendations();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error("Error while fetching recommendations")
        }
      })
  }

  public editRecommendation(recomm) {
    const s = this.modalService.open(RecommandationsFormComponent);
    s.componentInstance.editRecommId = recomm.id;
    s.componentInstance.name = recomm.nameOfServiceProvider
    s.componentInstance.contactDetails = recomm.phone
    s.componentInstance.company = recomm.company
    s.componentInstance.usp1 = recomm.uniqueSellingPointOne
    s.componentInstance.usp2 = recomm.uniqueSellingPointTwo
    s.componentInstance.isEdit = true



    s.hidden.subscribe({
      next: () => {
        this.fetchRecommdations();

      }
    });


  }

  public openAddRecommendationForm() {


    const s = this.modalService.open(RecommandationsFormComponent)
    s.hidden.subscribe({
      next: () => {
        this.fetchRecommdations();

      }
    });

  }

  public imageUrl = environment.ImageUrl

  public tabs = [{ title: 'My Recommendations' }, { title: 'Latest' }]

  public onTabChange(tabIndex) {

  }

  public async deleteRecomm(recomm) {
    const confirmation = await this.local.confirmYesNo({
      title: 'Delete recommendation',
      text: 'Are you sure you want to delete recommendation?',
      icon: 'warning'
    })
    if (confirmation.isConfirmed) {
      this.auth.deleteRecommendation(recomm.id).subscribe({
        next: () => {
          this.fetchRecommdations();
        },
        error: err => {
          console.error(err);
          this.toastr.error("Error something went wrong when deleting recommendation")
        }
      })

    } else {
      this.toastr.info("Deleting recommendation cancelled")
    }


  }
  public like(recomm) {
    this.auth.toggleRecommendationReaction(recomm.id)
      .subscribe({
        next: (data) => {
          recomm.haveILiked = !recomm.haveILiked
          if (recomm.haveILiked) {
            recomm.likeCounts += 1
          } else {
            recomm.likeCounts -= 1
          }
        },
        error: (err) => {
          console.error(err);
          this.toastr.error("Unable to like please try again latter")
        }
      })
  }

  public selectedMemberRegion
  ngOnInit(): void {

    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.user = user;
      }
      this.fetchRecommdations();
    });
    this.store.pipe(select(selectUser)).pipe(filter(user => !!user)).subscribe((r: User) => {
      if (r?.regionName) {
        this.selectedMemberRegion = r.regionName;
        this.auth.getCountsOfRecommendationCategoriestInSubRegion(Number(r.region)).subscribe({
          next: (data: any) => {
            this.catsCount = data.data.filter(cat => cat.recommendationCounts && cat.name?.trim());
            this.catsCount.forEach(cat => cat.selected = true)

          },
          error: (err) => {
            console.error(err);
            this.toastr.error("Something went wrong while fetching counts")
          }
        })
        //this._getMemberShopProduct(); 

      }
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
